import React from "react";
import '../css/footer.css';
import FullLogo from './../img/logo/full_name_logo.png'
import { FaFacebookSquare, FaInstagram, FaPhoneSquare  } from "react-icons/fa";
import { MdEmail } from "react-icons/md";


function Footer() {


    return (

        <footer id="Footer">
           <div className="container footer__container">
                <div className="footer__content">
                    
                    <div>
                        <img src={FullLogo} alt="slogan" />
                    </div>

                    <div className="operating">
                       <h2>Operating Hours</h2>
                       <p className="text_nofont">Open 7 days - 8am to 5pm</p>
                    </div>

                
                    <div className="connect">
                        <h2>Connect</h2>
                        <div className="socail">
                            
                            <a href="https://www.facebook.com/jjinkkultura/" rel="noreferrer" target='_blank'><FaFacebookSquare /></a>
                            <a href="https://www.instagram.com/inkkultura/" rel="noreferrer" target='_blank'><FaInstagram /></a>
                            <a href="mailto:jhonson_mendoza@yahoo.com"><MdEmail /></a>
                            <a href="tel:+64223139374"><FaPhoneSquare /></a>
                            
                        </div>
                    </div>

                    <div className="legal">
                        <h2>Legal</h2>
                        <div className="legal_grid">
                            <a href="/privacy-term" className="text_nofont">Privacy Policy</a>
                            <a href="/term-and-comdintion" className="text_nofont">Terms and Conditions</a>
                        </div>
                    </div>
                </div>

                <div className="copyright__content">
                    <p>Copyright &copy; 2024 Ink Kultura | Developed by </p>

                </div>
           </div>

        </footer>

    );


}

export default Footer;